module.exports = __webpack_public_path__ + "static/img/manual-11.341a5e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-11.png
// module id = iWMx
// module chunks = 4